<app-navigation-header title="Add Property" i18n-title="@@addPropertyMainTab-addPropertyTitle" svgName="sl-add">
	<div class="mat-stepper-navigator">
		<button
			mat-button
			(click)="movePrevious(stepperRef)"
			class="secondary-stepper-button"
			i18n="@@addPropertyMainTab-backButton"
			data-automation-id="add-property-back-button"
		>
			Back
		</button>
		<button
			mat-flat-button
			class="primary-stepper-button"
			[disabled]="!isValid(stepperRef) || serverCallInProgress"
			(click)="moveNext(stepperRef)"
			data-automation-id="add-property-next-button"
		>
			{{ getNextButtonLabel(stepperRef) }}
		</button>
	</div>
	<mat-horizontal-stepper linear #stepperRef>
		<mat-step>
			<ng-template matStepLabel i18n="@@addPropertyMainTab-1/Information">Information</ng-template>
			<app-add-property-details [editProperty]="editProperty" [propertyType]="propertyType"> </app-add-property-details>
		</mat-step>

		<mat-step>
			<ng-template matStepLabel i18n="@@addPropertyMainTab-2/Confirmation">Confirmation</ng-template>
			<app-add-property-confirmation [editProperty]="editProperty" [propertyType]="propertyType">
			</app-add-property-confirmation>
		</mat-step>
	</mat-horizontal-stepper>
</app-navigation-header>
